<template>
    <div class="user-profile-change-password-wrap">
        <div class="user-edit-profile-head">
            <h1 class="fs-17 bg-gray mb-20px p-3 radius-4 d-flex align-center justify-content-between">
                Change Password
            </h1>
        </div>

        <div class="user-edit-profile-form">
            <el-form label-position="top">
                <div class="user-edit-profile-form-box mb-20px">
                    <el-row :span="24">
                        <el-col :span="8">
                            <el-form-item label="Current Password">
                                <el-input type="password" size="large" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="New Password">
                                <el-input type="password" size="large" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="New Password (again)">
                                <el-input type="password" size="large" />
                            </el-form-item>
                        </el-col>

                    </el-row>
                </div>
                
                <el-row>
                    <el-col>
                        <el-button class="btn theme-btn user-profile-save-btn">Change Password</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </div>
</template>

<script>

export default {
    name: 'UserProfileChangePassword',
    components: {
    },
    data() {
        return {
            
        }
    }
}
</script>